import React, { useEffect, useState, Fragment } from "react";
import { Container, Row, Col } from 'reactstrap';
import { useHistory, useLocation, withRouter } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";

import Header from "./Header";
import RegOverlay from "./RegOverlay";
import SeekerSignIn from "./SigninOverlay";
import Carriers from "./Carriers";
import TC from "./TC";
import PrivacyPolicy from "./PrivacyPolicy";
import Unsubscribe from "./Unsubscribe";
import DMCA from "./DMCA";
import CalPrivacy from './CalPrivacy';
import CalDoNotSell from './CalDoNotSell';
import RelatedJobs from "./RelatedJobs";
import Footer from "./Footer";
import JobDescription from "./JobDescription";
import ExpiredJob from "./ExpiredJob";
import Banner from "./BottomBanner";

const MainPage = () => {
    const windowLocation = useLocation();
    const [hasLoaded, setHasLoaded ] = useState(false);
    const [redirect, setRedirect] = useState("");
    const [disabledEmpRedir, setDisabledEmpRedir] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    //Overlays
    const [showRegOverlay, setShowRegOverlay] = useState(true);
    const [showSignin, setShowSignin] = useState(false);
    const [showCarriers, setShowCarriers] = useState(false);
    const [showTC, setShowTC] = useState(false);
    const [showPP, setShowPP] = useState(false);
    const [showUnsub, setShowUnsub] = useState(false);
    const [showDMCA, setShowDMCA] = useState(false);
    const [showCalPriv , setShowCalPriv] = useState( false );
    const [showCalPersonal , setShowCalPersonal] = useState( false );
    //Job data
    const [deFormJson, setDeFormJson] = useState({});
    const [jobTitle, setJobTitle] = useState("");
    const [jobCompany, setJobCompany] = useState("");
    const [jobLocation, setJobLocation] = useState("");
    const [jobCity, setJobCity] = useState("");
    const [jobState, setJobState] = useState("");
    const [jobZip, setJobZip] = useState("");
    const [jobPosted, setJobPosted] = useState("");
    const [jobURL, setJobURL] = useState("");
    const [jobDescription, setJobDescription ] = useState("");
    const [jobLogo, setJobLogo] = useState("");
    const [jobSearch, setJobSearch] = useState("");
    const [trafficType, setTrafficType] = useState("application_click");
    const [jobPage, setJobPage] = useState("");
    const [coregJobState, setCoregJobState] = useState("");
    const [jobDetailsLocation, setJobDetailsLocation] = useState("");
    const [jobEmpType, setJobEmpType] = useState("");
    const [jobComp, setJobComp] = useState("");
    //User data
    const [loggedIn, setLoggedIn] = useState(false);
    const [duplicateUser, setDuplicateUser] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [userPhone, setUserPhone] = useState("");
    const [userFName, setUserFName] = useState("");
    const [userLName, setUserLName] = useState("");
    const [userId, setUserId] = useState(0)
    const [profileLoc, setProfileLoc] = useState("");
    const [hasResume, setHasResume] = useState("");
    const [resumeNeeded, setResumeNeeded] = useState("");
    const [sessionId, setSessionId] = useState("");
    // IDs & Related jobs
    const [relatedJobs, setRelatedJobs] = useState([]);
    const [expiredJob, setExpiredJob] = useState(false);
    const [solrJtid, setSolrJtid] = useState("");
    const [CID, setCID] = useState("");
    const [crid, setCrid] = useState(0);
    const [cptid, setCptid] = useState("");
    const [catid, setCatid] = useState("");
    const [SID, setSID] = useState("");
    const [JFORGID, setJFORGID] = useState("");
    const [siteId, setSiteId] = useState(71);
    const [OID, setOID] = useState("");
    const [ueid, setUeid] = useState("");
    const [XOID, setXOID] = useState("");
    const [FID, setFID] = useState("");
    const [termsText, setTermsText] = useState("");
    const [pageTitle, setPageTitle] = useState("Upward - Find a Job. Move Upward.");

    const [keymapid, setKeymapid] = useState("");
    const [seJk, setSeJk] = useState(0);

    const qs = queryString.parse(windowLocation.search);
    const params = new URLSearchParams(window.location.search)

    const history = useHistory();

    const redirectBaseUrl = process.env['REACT_APP_ENV'] === 'dev' ? process.env['REACT_APP_JOBS_APP_BASE_URL'] : ''

    const childProps = { 
      history, qs, OID, XOID, solrJtid, crid, SID, CID, jobSearch, jobLocation, jobCity, jobState, jobZip, userEmail, userPhone, userFName, userLName, seJk, userId, keymapid, trafficType, jobTitle, siteId, cptid, JFORGID, FID, ueid, catid, profileLoc, jobPage, jobCompany, duplicateUser, hasResume, resumeNeeded, termsText, sessionId, coregJobState, jobURL, setShowRegOverlay, setShowCarriers, setLoggedIn, ccT, isMobile, deFormJson, redirectBaseUrl
    };

    const modalProps = {
    	setShowTC, setShowPP, setShowDMCA, setShowCalPriv, setShowCalPersonal, setShowUnsub, openCmpDrawer, redirectBaseUrl
    };

    function ccT(o, e, cidval, sidval, cridval) {
      var ccTStr = process.env['REACT_APP_API_URL'] + '/search/ccTotalNet.fsn?event_id='+e+'&oid='+o+'&CID='+cidval+'&count=1&SID='+sidval+(cridval ? '&CRID=1' : '');
      axios.get(ccTStr).then((response) => {
        
      }).catch(function (error) {
          console.log(error);
      })
    }

    function openCmpDrawer () {
      if (window.Osano.cm.countryCode === 'us') {
        window.Osano.cm.showDoNotSell();
      } else {
        window.Osano.cm.showDrawer();
      }
    }

    useEffect(() => {
      if (window.location.pathname == '/privacy_policy') {
        setShowRegOverlay(false);
        setShowPP(true);
      }
    }, []);

    useEffect(() => {
      document.title = jobTitle+" | Upward - Find a Job. Move Upward.";
    }, [jobTitle]);

    useEffect(() => {
      if (qs && qs.page) {
        setJobPage(params.get('page'));
      }
      if (qs && qs.preview && qs.preview === "y" ) {
        setShowRegOverlay(false);
      }
    }, [qs]);

    useEffect(() => {
      if(qs && qs.page && qs.page === "7" && redirect !== ""){
        window.location = redirect;
      }
    }, [redirect, qs]);

    useEffect(() => {
      if(disabledEmpRedir !== "" && disabledEmpRedir !== undefined){
        window.location = disabledEmpRedir;
      }
    }, [disabledEmpRedir]);

    useEffect(() => {
        axios.get(qs && qs.page && qs.page === "job" ? process.env['REACT_APP_API_URL']+"/upward/jobPageTest2.jsp"+window.location.search : process.env['REACT_APP_API_URL']+"/upward/jobPageTest.jsp"+window.location.search)
            .then(function(response){
                setFID(response.data.fid);
                setDeFormJson(response.data.deFormJson !== null && response.data.deFormJson !== undefined ? response.data.deFormJson : "");
                setJobTitle(response.data.title);
                setJobCompany(response.data.company);
                setJobLocation(response.data.location);
                setJobCity(response.data.city);
                setJobState(response.data.state);
                setCoregJobState(response.data.jobState);
                setJobZip(response.data.zip);
                setJobPosted(response.data.postedDate);
                setJobURL(response.data.joburl);
                setJobLogo(response.data.metaImage);
                setJobSearch(response.data.jobsearch);
                setUserEmail(response.data.userEmail);
                setUserFName(response.data.userFName);
                setUserLName(response.data.userLName);
                setSessionId(response.data.sessionId);
                setUserPhone(response.data.userPhone);
                setIsMobile(response.data.isMobile);
                setCID(response.data.CID);
                setUeid(response.data.ueid);
                setUserId(response.data.userId);
                setCrid(response.data.crid);
                setLoggedIn(response.data.loggedIn);
                setDuplicateUser(response.data.duplicateUser);
                setJobDescription(response.data.jobDescription);
                setProfileLoc(response.data.profileLoc);
                setCatid(response.data.catid);
                setDisabledEmpRedir(response.data.disabledRedirect !== undefined ? response.data.disabledRedirect : response.data.disabledRedirect);
                setSID(response.data.SID);
                setSolrJtid(response.data.solrjtid);
                setHasResume(response.data.hasResume);
                setResumeNeeded(response.data.resumeNeeded);
                setKeymapid(response.data.keymapid);
                setOID(response.data.OID);
                setXOID(response.data.xoid);
                setCptid(response.data.cptid);
                setSeJk(response.data.seJk);
                setTermsText(response.data.coRegAdvertisers);
                setJFORGID(response.data.jforgid);
                setTrafficType(response.data.trafficType);    
                setJobDetailsLocation(response.data.jobDetailsLocation);
                setJobEmpType(response.data.employmentType);
                setJobComp(response.data.compensation);
                setRedirect(response.data.redirect);
                setHasLoaded(true);
                setExpiredJob(false);
                ccT(101, 1, response.data.CID, response.data.SID, response.data.isMobile);
                setIsLoading(false);
                axios.get(process.env['REACT_APP_API_URL']+"/upward/jobExtraOfferJobPull_json.jsp?keyword="+response.data.jobsearch+"&location="+response.data.location+"&CID="+response.data.CID)
                    .then(function(response){
                        setRelatedJobs(response.data);
                    })
                    .catch(function(error){
                        console.log(error);
                        window.Rollbar.error("jobExtraOfferJobPull_json error", error);
                    });
        })
        .catch(function(error){
          console.log(error);
          setIsLoading(false);
          window.Rollbar.error("jobPageTest1/2 error", error);
          setExpiredJob(true);
        });
    }, []);    

    window.optinsHandler = {
        resumeOptinId : null,
        totalOptins : 0,
        renderOptins : function(data){
          this.totalOptins = data.length;
          var emailCoregOptinFlow = true;
          var renderedFirst = false;
          var str = "";
          for( var i = 0 ; i < data.length ; i++ ){
            var det = data[i];
            if( emailCoregOptinFlow && !renderedFirst ){
              if( det.type == "resume" ){
                this.resumeOptinId = det.id;
                renderedFirst = true;
                this.totalOptins = data.length-1;
              } else {
                str += this.singleRender( det );
              }
            } else {
              str += this.singleRender( det );
            }
          }
          this.element().html(str);
        },
        element : function(){
        },
        singleRender : function(det){
          var str = '<div class="">'+
            '<div class="well well-sm">'+
              '<div class="row">'+
                '<div class="col-xs-1">'+
                  '<div class="clearfix">'+
                    '<input checked type="checkbox" class="resumeOptinRadio" value="'+det.id+'" name="resume_optin_'+det.name.replace(" ","_").toLowerCase+'" id="resume_optin_'+det.name.replace(" ","_").toLowerCase+'1">'+
                  '</div>'+
                '</div>'+
                '<div class="col-xs-11">'+
                  '<div class="resumeOptinDescription">'+
                  '<p>'+det.lang+'</p>'+
                  '</div>'+
                '</div>'+
              '</div>'+
            '</div>'+
          '</div>';
          return str;
        }
      }

    return (
      <>
        <Banner setShowPP={setShowPP} setShowTC={setShowTC}/>
        <section className="jobContainer">
            <Header loggedIn={loggedIn} history={history} query={qs} jobLocationFromAPI={jobLocation} setShowSignin={setShowSignin} fName={userFName} redirectBaseUrl={redirectBaseUrl} />
            {showRegOverlay && jobPage.toLowerCase() !== "s" && trafficType !== "application_click" && <RegOverlay {...childProps}/>}
            {showSignin && <SeekerSignIn setShowSignin={setShowSignin} setLoggedIn={setLoggedIn} setShowRegOverlay={setShowRegOverlay} />}
            {showCarriers && <Carriers setShowCarriers={setShowCarriers} />}
            {showTC && <TC setShowTC={setShowTC} setShowCarriers={setShowCarriers} setShowPP={setShowPP} redirectBaseUrl={redirectBaseUrl} />}
            {showPP && <PrivacyPolicy setShowPP={setShowPP} setShowTC={setShowTC} setShowCalPriv={setShowCalPriv} setShowUnsub={setShowUnsub} openCmpDrawer={openCmpDrawer} />}
            {showUnsub && <Unsubscribe setShowUnsub={setShowUnsub} />}
            {showDMCA && <DMCA setShowDMCA={setShowDMCA} />}
            {showCalPriv && <CalPrivacy setShowCalPriv={setShowCalPriv} setShowPP={setShowPP} />}
            {showCalPersonal && <CalDoNotSell setShowCalPersonal={setShowCalPersonal} />}
            {isLoading && <div className={"loading " + (isLoading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>}
            { (expiredJob || (!jobTitle && !jobCompany && !jobDescription && hasLoaded))
            ? <ExpiredJob redirectBaseUrl={redirectBaseUrl} />
            :
            <section>
                <Row>
                    <Col className="col-xs-10 col-xs-offset-1">
                        <JobDescription qs={qs} jobDetailsLocation={jobDetailsLocation} jobEmpType={jobEmpType} jobComp={jobComp} setShowRegOverlay={setShowRegOverlay} jobPage={jobPage} jobSearch={jobSearch} trafficType={trafficType} jobTitle={jobTitle} jobCompany={jobCompany} jobDescription={jobDescription} jobLocation={jobLocation} jobPosted={jobPosted} jobURL={jobURL} jobLogo={jobLogo} redirectBaseUrl={redirectBaseUrl} />
                    </Col>
                </Row>
            </section>
        	}
	        <section>
	            <Row style={{"padding": "0 15px"}}>
	                <Col>
	                    <div className="similarJobsWrapper">
	                        <h4>Related Jobs</h4>
	                        <ul className="similarJobsList list-unstyled">
	                            {relatedJobs.length > 0 && relatedJobs.map((job, index) => (
	                                <Fragment key={job.jobId + "_" + index} >
	                                    <RelatedJobs job={job} />
	                                </Fragment>
	                            ))}
	                        </ul>
	                    </div>
	                </Col>    
	            </Row>
	            <Row>
	                <Col>
	                    <Footer {...modalProps} />
	                </Col>
	            </Row>
	        </section>
        </section>
        </>
    )
}

export default withRouter(MainPage);